import { useState } from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import WarningIcon from '@mui/icons-material/Warning';
import CircularProgress from '@mui/material/CircularProgress';
import graphQLClient from '../../../helpers/graphQLClient';
import { STRIPE_CUSTOMER_PORTAL_LINK } from '../../../helpers/graphql/stripe';
import { useIsIosApp } from '../../../helpers/appPlatform';

export default function StarterTrialExpired({ blogId }) {
  const [loading, setLoading] = useState(false);
  const inIosApp = useIsIosApp();

  const handleUpgrade = () => {
    setLoading(true);
    graphQLClient(STRIPE_CUSTOMER_PORTAL_LINK, { blogId })
      .then(res => {
        if (res?.stripeCustomerPortalLink) {
          const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
          if (isIOS) {
            window.open(res.stripeCustomerPortalLink, '_blank');
          } else {
            window.location.href = res.stripeCustomerPortalLink;
          }
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  return (
    <div className="tw-bg-amber-50 tw-border tw-border-amber-200 tw-rounded-lg tw-p-6 tw-text-center">
      <WarningIcon className="tw-text-amber-500" style={{ fontSize: 48 }} />
      <Typography variant="h6" className="tw-mt-3 tw-text-amber-800">
        Your 30-Day Blog Trial Has Expired
      </Typography>
      <Typography variant="body2" className="tw-mt-2 tw-mb-4 tw-text-gray-700">
        Your Starter plan blog hosting trial has ended. Upgrade to Basic, Pro,
        or VIP to continue hosting your blog with a custom domain. Your posts
        are still accessible on TravelFeed, and you keep your verified badge and
        AI credits.
      </Typography>
      {inIosApp ? (
        <Typography variant="body2" className="tw-text-gray-600">
          Upgrades are not available in this app.
        </Typography>
      ) : (
        <div className="tw-flex tw-flex-wrap tw-justify-center tw-gap-3">
          <Button
            variant="contained"
            color="primary"
            onClick={handleUpgrade}
            disabled={loading}
            size="large"
          >
            Upgrade Your Plan
            {loading && (
              <CircularProgress className="tw-ml-2" size={20} color="inherit" />
            )}
          </Button>
        </div>
      )}
    </div>
  );
}
